import { render, staticRenderFns } from "./admin-helper.vue?vue&type=template&id=e5c28d3a&scoped=true"
import script from "./admin-helper.vue?vue&type=script&lang=js"
export * from "./admin-helper.vue?vue&type=script&lang=js"
import style0 from "./admin-helper.vue?vue&type=style&index=0&id=e5c28d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c28d3a",
  null
  
)

export default component.exports